import React, { useState } from 'react';
import Input from '../Input';
import Button from '../Button';
import ModalPage from '../ModalPage';
import useAPI from '../../hooks/useAPI';
import useFlash from '../../hooks/useFlash';
import FlashMessage from '../FlashMessage';
import { useFormatter } from '../../hooks/useFormatter';

export default function RequirePasswordChange({ email, token }) {
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [errors, setErrors] = useState({});

  const api = useAPI();
  const formatter = useFormatter();
  const { messages, flash, remove } = useFlash();

  const submit = () => {
    const newErrors = {};

    if (!password) {
      newErrors.password = 'Password required';
    } else if (password.length < 12) {
      newErrors.password = 'Passwords must contain at least 8 characters';
    } else if (!/[0-9]+/.test(password)) {
      newErrors.password = 'Passwords must contain at least 1 number';
    }

    if (!repeatPassword) {
      newErrors.repeatPassword = 'Repeated password required';
    } else if (repeatPassword !== password) {
      newErrors.repeatPassword = 'Passwords do not match';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setBusy(true);
    api.json('POST', '/auth/reset-password', {
      password,
      email,
      token
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.errors) {
          setErrors({
            ...formatter.flattenErrors(response.errors)
          });
          return;
        }

        flash('Your password has been updated.', 'success');
        setPassword('');
        setRepeatPassword('');
        setTimeout(() => {
          const auth = api.cookie('auth');
          auth.require_password_change = false;
          api.cookie('auth', auth);
          window.location.reload(true);
        }, 1500);
      })
      .catch((err) => alert(err))
      .finally(() => setBusy(false));
  };

  return (
    <ModalPage title="Change Your Password" style={{ backgroundColor: '#485CC7' }}>
      <div style={{ textAlign: 'center', marginBottom: 10 }}>
        For security reasons, please update your password before continuing.
      </div>

      <Input
        error={errors.password}
        label="New Password"
        maxLength="40"
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
          setErrors({ ...errors, password: '' });
        }}
        type="password"
      />

      <Input
        error={errors.repeatPassword}
        label="Repeat New Password"
        maxLength="40"
        value={repeatPassword}
        onChange={(e) => {
          setRepeatPassword(e.target.value);
          setErrors({ ...errors, repeatPassword: '' });
        }}
        type="password"
      />

      <FlashMessage messages={messages} onRemove={remove} />
      <Button
        busy={busy}
        disabled={busy || !password || !repeatPassword}
        className="button-full button-primary"
        onClick={submit}
      >
        Change Password
      </Button>
    </ModalPage>
  );
}
